import React from 'react'
import { Heading } from '../../../../components/Print/Heading'
import PrintArticleImage from './PrintArticleImage'
import BylineAndSocial from './BylineAndSocial'
import styled from '@emotion/styled';
import { device } from '../../../../components/Print/device';


interface IArticleTopSectionProps {
  articleShowData: { [key: string]: any }
  isWapView: boolean
  textSize?: string
  changeSize?: (val: string) => void
  scrollToBlocker?: (() => void) | undefined
  isUserPrime: boolean
  comments: any
  msid: string
}

function ArticleTopSection(props: IArticleTopSectionProps) {
  const { articleShowData, isWapView, textSize, changeSize, scrollToBlocker, isUserPrime, comments, msid } = props;

  return (
    <PrintArticleWrapper>
      {articleShowData.hl ? <Heading variant='h1'>{articleShowData.hl}</Heading> : null}
      <BylineAndSocial articleShowData={articleShowData} isWapView={isWapView} textSize={textSize} changeSize={changeSize} scrollToBlocker={scrollToBlocker} isUserPrime={isUserPrime} comments={comments} msid={msid} />
      <PrintArticleImage articleShowData={articleShowData} scrollToBlocker={scrollToBlocker} isUserPrime={isUserPrime} isWapView={isWapView} />
    </PrintArticleWrapper>
  )
}

const PrintArticleWrapper = styled.section`
  padding:32px 0 0 0;
  & > h1{
    line-height: 44px;
  }
  @media screen and ${device.mobile},
    screen and (orientation: landscape) and (max-width: 1000px) {
    padding:24px 24px 0;
    & > h1{
      font-size: 24px;
      line-height: 32px;
    }
  }
`

export default ArticleTopSection